module.exports = {
      id: "blue-check-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#blue-check",
      toString: function () {
        return this.url;
      }
    }